/**
 * Decode HTML entities in text
 * Converts HTML entities like &Ograve; to their actual characters like Ò
 */
export const decodeHtmlEntities = (text) => {
  if (!text || typeof text !== 'string') {
    return text;
  }

  // Use browser's built-in HTML entity decoder
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
};

